import { render, staticRenderFns } from "./custom.vue?vue&type=template&id=3a1b9820&scoped=true"
import script from "./custom.vue?vue&type=script&lang=js"
export * from "./custom.vue?vue&type=script&lang=js"
import style0 from "./custom.vue?vue&type=style&index=0&id=3a1b9820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1b9820",
  null
  
)

export default component.exports